import { render, staticRenderFns } from "./FooterSocialSocial.vue?vue&type=template&id=703a6445&scoped=true&"
import script from "./FooterSocialSocial.vue?vue&type=script&lang=js&"
export * from "./FooterSocialSocial.vue?vue&type=script&lang=js&"
import style0 from "./FooterSocialSocial.vue?vue&type=style&index=0&id=703a6445&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703a6445",
  null
  
)

export default component.exports